import Vue from 'vue'
import Router from 'vue-router'
import Evaluation from '@/components/evaluation'
import EditVoc from '@/components/edit-voc'
import Home from '@/components/home'
import Voc from '@/components/voc'

Vue.use(Router)

const router = new Router({
	base: '/',
	routes: [
		{
			path: '/',
			name: 'name',
			component: Home
		},
		{
			path: '/test/:voc',
			name: 'test',
			component: Evaluation
		},
		{
			path: '/form/:voc',
			name: 'editVoc',
			component: EditVoc
		},
		{
			path: '/voc/:voc',
			name: 'voc',
			component: Voc
		}
	]
})

export default router